import { render, staticRenderFns } from "./AlertStreamList.vue?vue&type=template&id=37a48514&scoped=true&"
import script from "./AlertStreamList.vue?vue&type=script&lang=js&"
export * from "./AlertStreamList.vue?vue&type=script&lang=js&"
import style0 from "./AlertStreamList.vue?vue&type=style&index=0&id=37a48514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a48514",
  null
  
)

export default component.exports